"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconBOL = function SvgIconBOL(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "b o l icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'B O L Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M44.075 28.693v9.78l-8.466 4.889v-9.78l.94-.545 7.526-4.344zm-18.43.052l3.213 1.85v2.49l1.558.801v-2.381l3.634 2.094v9.71l-8.405-4.853v-9.71zM13.651 4h17.247a5.618 5.618 0 015.607 5.391l.005.22v8.628a1.403 1.403 0 01-2.8.135l-.006-.135V9.61a2.81 2.81 0 00-2.635-2.8l-.17-.005H13.65a2.81 2.81 0 00-2.8 2.635l-.005.17V34.3a2.81 2.81 0 002.635 2.8l.17.006h4.692a1.403 1.403 0 01.135 2.8l-.135.006H13.65a5.618 5.618 0 01-5.607-5.392l-.004-.22V9.611a5.618 5.618 0 015.391-5.607L13.65 4h17.247zM39.77 25.268l3.752 2.137-5.458 3.155-3.239 1.868-3.256-1.88-.496-.257 8.697-5.023zm-4.945-2.886l3.256 1.884-8.697 5.023-3.26-1.884 8.701-5.023zM23.822 23.64a1.403 1.403 0 01.135 2.799l-.135.006h-8.776a1.403 1.403 0 01-.135-2.799l.135-.006h8.776zm5.674-5.612a1.403 1.403 0 01.135 2.8l-.135.006h-14.45a1.403 1.403 0 01-.135-2.8l.135-.006h14.45zm0-5.611a1.403 1.403 0 110 2.806h-14.45a1.403 1.403 0 110-2.806z"
  }));
};

var _default = SvgIconBOL;
exports.default = _default;